/*eslint-disable */

import {bus} from '@/main';
import userImageBox from '@/components/private/userimage/index';
import userList from '@/components/private/user-list-table';

var $ = window.jQuery = require('jquery');

export default {
  name: 'adminDashboard',
  components: {
    'user-image': userImageBox,
    'user-list': userList
  },
  props: [],
  data() {
    return {
      preloader: true
    }
  },
  computed: {

  },
  mounted() {
    // bus.$emit('authBtnShowBus', true)
    // $('.app-loader').hide();
  },
  methods: {

  },
  beforeCreate: function() {
  },
  beforeRouteLeave: function(to, from, next) {
    next();
  },
}